import React from "react";

interface IfProps {
    children: React.ReactNode;
    condition: boolean;
}

const If: React.FC<IfProps> = ({ condition, children }: IfProps) => {
    if (condition) {
        return <>{children}</>;
    }

    return null;
};

export default If;
